// extracted by mini-css-extract-plugin
module.exports = {"box":"box__1W0Bn","icon":"icon__1DZQS","plus":"plus__3UMAX"};